export enum PopupType {
  Success = 0,
  Error = 1,
  Warning = 2,
  Loading = 3,
}

export interface PopupDescription {
  visible: boolean;
  popupType: PopupType;
  message?: string;
}

export const successPopup = (message?: string) => {
  return {
    visible: true,
    popupType: PopupType.Success,
    message,
  };
};

export const errorPopup = (message?: string) => {
  return {
    visible: true,
    popupType: PopupType.Error,
    message,
  };
};

export const warningPopup = (message?: string) => {
  return {
    visible: true,
    popupType: PopupType.Warning,
    message,
  };
};
